module.exports = __webpack_public_path__ + "static/media/redesign-logo.32452818.png";